import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { CriteriumSkeleton, CriteriumKeywordsCloudTag } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  root: { maxWidth: '650px' },
  keyword: {
    marginRight: theme.spacing(1)
  }
}));

interface CriteriumKeywordsCloudProps {
  keywords: { keyword: string; url?: string; amount: number }[]
  color: string
}

export const CriteriumKeywordsCloud = ({ keywords, color }: CriteriumKeywordsCloudProps) => {
  const classes = useStyles();
  const { variant } = useReviewContext();
  return (
    <div className={classes.root}>
      {keywords && keywords.length
        ? keywords.map(keyword =>
          <CriteriumKeywordsCloudTag
            key={keyword.keyword}
            className={classes.keyword}
            {...keyword}
            color={color}
          />
          )
        : (variant === 'nocrit' ? <CriteriumSkeleton width='50%' /> : <Translate content='not_found' />)}
    </div>
  );
};

export default CriteriumKeywordsCloud;
